import React from 'react'
import { Input, Button as AntButton } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import type { TableColumn } from '../../../../ui_configs/table_grid.ts'

interface StandardEditCellProps<T = any> {
  column: TableColumn<T>
  item: T
  value: any
  onChange: (value: any) => void
  onSave: () => void
  onCancel: () => void
}

export default function StandardEditCell<T = any>({ value, onChange, onSave, onCancel }: StandardEditCellProps<T>) {
  return (
    <div className='flex flex-col' style={{ gap: '2px', width: '100%' }}>
      <div className='flex items-center' style={{ gap: '2px' }}>
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Escape') {
              onCancel()
            } else if (e.key === 'Enter') {
              onSave()
            }
          }}
          size='small'
          autoFocus
          style={{ flex: 1 }}
        />
        <AntButton
          type='text'
          size='small'
          icon={<FontAwesomeIcon icon={faCheck} style={{ color: '#10b981' }} />}
          onClick={onSave}
          style={{ padding: '0 4px', minWidth: 'auto' }}
        />
        <AntButton
          type='text'
          size='small'
          icon={<FontAwesomeIcon icon={faTimes} style={{ color: '#ef4444' }} />}
          onClick={onCancel}
          style={{ padding: '0 4px', minWidth: 'auto' }}
        />
      </div>
    </div>
  )
}
